import { render, staticRenderFns } from "./StockingsPage.vue?vue&type=template&id=47b23a6a&"
import script from "./StockingsPage.vue?vue&type=script&lang=js&"
export * from "./StockingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports